import { SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import WireRecipientAddForm from '@/components/wireRecipients/add/WireRecipientAddForm';
import { ROUTES } from '@/constants/routes';
import { useGetCustomerDetails } from '@/hooks/requests/useCustomers';
import { Card, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

export default function WireRecipientsAddPage() {
  const navigate = useNavigate();
  const { customerId = '' } = useParams();
  const { isCustomerDetailsPending, customerDetails } =
    useGetCustomerDetails(customerId);

  if (isCustomerDetailsPending) {
    return (
      <DefaultLayout header="Add Wire Recipient">
        <SVLoader />
      </DefaultLayout>
    );
  }

  if (!customerDetails) {
    return (
      <DefaultLayout header="Add Wire Recipient">
        <Card>
          <Typography>
            Something went wrong retreiving the customer information. Our team
            has been notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  const { firstName, lastName, email } = customerDetails;

  return (
    <DefaultLayout
      header="Add Wire Recipient"
      subheader={
        <Typography>
          To link{' '}
          <Typography component="span" fontWeight="bold">
            {firstName} {lastName} ({email})
          </Typography>
          's external account, please fill in the following details.
        </Typography>
      }
      breadcrumb={[
        { label: 'Customers', href: ROUTES.CUSTOMERS },
        {
          label: `${firstName} ${lastName}`,
          href: `${ROUTES.CUSTOMERS}/${customerId}`,
        },
        {
          label: 'Wire Recipients',
          href: `${ROUTES.CUSTOMERS}/${customerId}${ROUTES.WIRE_RECIPIENTS}`,
        },
        { label: 'Add Wire Recipient', isActive: true },
      ]}>
      <WireRecipientAddForm
        customerId={customerId}
        onLeave={() =>
          navigate(`${ROUTES.CUSTOMERS}/${customerId}${ROUTES.WIRE_RECIPIENTS}`)
        }
      />
    </DefaultLayout>
  );
}
